import { ReviewerCardProps } from "@/interfaces";
import TypoGraphy from "@/typography";
import './index.scss';
const ReviewerCard = ({
  name,
  designation,
  companyName,
  reviewerImage
}: ReviewerCardProps) => {
  return <div className="reviewer_card_wrapper" data-sentry-component="ReviewerCard" data-sentry-source-file="index.tsx">
        <img className="reviewer_image_wrapper" src={reviewerImage} alt="reviewer" loading='lazy'></img>
        <div className="reviewer_content_wrapper">
            <TypoGraphy text={name} variant='Body 1/Medium/16|120%' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
            <TypoGraphy text={`${designation}, ${companyName}`} variant='Desktop/Body 2/R | 14 |120' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
        </div>
    </div>;
};
export default ReviewerCard;